// removed by extract-text-webpack-plugin
module.exports = {"root":"_2dsAz6G","link":"_1hfdS4d","arrowContainer":"_3SJEx7k","arrowSvg":"_3Y4mREV"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultList/components/JobItem/components/JobClassification/JobClassification.less
 ** module id = 819
 ** module chunks = 0
 **/